<template>
  <v-sheet v-if="localData" class="d-flex justify-center overflow-auto" :height="height">
    <v-sheet class="align-self-center" max-width="400">
      <div class="pt-2 px-4">
        <v-text-field
            v-model="localData.data.name"
            label="Название"
            dense outlined hide-details="auto" clearable class="mb-4"
        />

        <v-row class="rowSmall">
          <v-col cols="12" class="caption pb-1">Дата / Время отправки</v-col>
          <v-col><date name="Дата" :value.sync="localData.data.sendDate"/></v-col>
          <v-col><tim name="Время" :value.sync="localData.data.sendTime"/></v-col>
        </v-row>

        <v-text-field
            label="Задержка между сообщениями (сек.)"
            v-model="localData.data.delay"
            type="number"
            clearable
            dense outlined hide-details="auto" class="mb-4"
        />

        <autocomplete-single
            name="Отправить через"
            :items="comContactState.data.items"
            :select.sync="localData.data.comContact"
            :loading="comContactState.loading"
        >
          <template v-slot:selectedInfo="{item}">
            <span>{{item.name}}</span>
            <dot/>
            <v-icon :color="item.info.messengerTypeIconBgColor" small>{{item.info.messengerTypeIcon}}</v-icon>
            <span class="text-no-wrap ml-1">{{item.info.messengerTypeStr}}</span>
            <dot v-if="item.phone!==null"/>
            <span v-if="item.phone!==null" class="text-no-wrap">{{$tools.phoneFormat(item.phone)}}</span>
          </template>
          <template v-slot:itemInfo="{item}">
            <div class="mt-1">
              <v-icon :color="item.info.messengerTypeIconBgColor" small>{{item.info.messengerTypeIcon}}</v-icon>
              <span class="text-no-wrap ml-1">{{item.info.messengerTypeStr}}</span>
              <dot v-if="item.phone!==null"/>
              <span v-if="item.phone!==null" class="text-no-wrap">{{$tools.phoneFormat(item.phone)}}</span>
            </div>
          </template>
        </autocomplete-single>
      </div>
    </v-sheet>
  </v-sheet>
</template>

<script>
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import Tim from "@/componentsV2/base/Tim.vue";
import Date from "@/componentsV2/base/Date.vue";
import Dot from "@/componentsV2/base/Dot.vue";
import {Entity_ComContact} from "../../../../../../EntityStoreCacheService";
import Stater from "@/plugins/stater";
export default {
  components: {Dot, Date, Tim, AutocompleteSingle},
  props: ['data','height'],
  data: () => ({
    localData:null,
    comContactState: new Stater({items:[],count:0})
  }),
  mounted() {
    this.localData = this.data;
    new Entity_ComContact()
        .selects(Entity_ComContact.id)
        .selects(Entity_ComContact.name)
        .selects(Entity_ComContact.messengerType)
        .selects(Entity_ComContact.phone)
        .virtual(Entity_ComContact.virtual_info)
        .order(Entity_ComContact.messengerType, true)
        .addStateCallback((v) => this.comContactState.setRequestBuilderState(v))
        .request()
  },
  watch: {
    data() {
      this.localData = this.data;
    },
    localData(){
      this.$emit('update', this.localData)
    },
  }
}
</script>